import {Pagination as AntdPagination} from 'antd';
import styled from 'styled-components';

import {ThemeVarNames} from '@theme';

export const Pagination = styled(AntdPagination)`
  color: var(${ThemeVarNames.SecondaryText});
  background-color: transparent;

  .ant-pagination-prev,
  .ant-pagination-next {
    color: inherit;

    .ant-pagination-item-link {
      color: inherit;
      background-color: inherit;
      border-color: var(${ThemeVarNames.Border});

      :hover {
        color: var(${ThemeVarNames.Action});
        border-color: var(${ThemeVarNames.Action});
      }

      :disabled {
        color: var(${ThemeVarNames.Disabled});
        border-color: var(${ThemeVarNames.Disabled});
      }

      :disabled:hover {
        color: var(${ThemeVarNames.DisabledDark});
        border-color: var(${ThemeVarNames.DisabledDark});
      }
    }
  }

  .ant-pagination-item {
    border-color: var(${ThemeVarNames.Border});
    background-color: inherit;

    a {
      color: inherit;
    }

    :hover {
      border-color: var(${ThemeVarNames.Action});

      a {
        color: var(${ThemeVarNames.Action});
      }
    }
  }

  .ant-pagination-item-active {
    border-color: var(${ThemeVarNames.Action});
    background-color: var(${ThemeVarNames.SecondaryBg});

    :hover a {
      color: var(${ThemeVarNames.Action});
    }
  }

  .ant-pagination-jump-next {
    .ant-pagination-item-ellipsis {
      color: var(${ThemeVarNames.SecondaryText});
    }

    :hover {
      border-color: var(${ThemeVarNames.Action});

      .ant-pagination-item-ellipsis {
        color: var(${ThemeVarNames.SecondaryText});
      }

      .ant-pagination-item-container {
        border: 1px solid var(${ThemeVarNames.Action});
      }
    }
  }

  .ant-pagination-jump-prev {
    .ant-pagination-item-ellipsis {
      color: var(${ThemeVarNames.SecondaryText});
    }

    :hover {
      border-color: var(${ThemeVarNames.Action});

      .ant-pagination-item-ellipsis {
        color: var(${ThemeVarNames.SecondaryText});
      }

      .ant-pagination-item-container {
        border: 1px solid var(${ThemeVarNames.Action});
      }
    }
  }
`;
